export const discover = {
  // Back button
  'discover.backButton.home': 'Retour à l\'accueil',
  'discover.backButton.homeShort': 'Accueil',

  // Hero section
  'discover.hero.title': 'Trouvez vos Subventions',
  'discover.hero.subtitle': 'Recherche intelligente pour trouver les aides publiques adaptées à votre projet',

  // Toast messages
  'discover.toast.startSearch.title': 'Commencez votre recherche',
  'discover.toast.startSearch.description': 'Décrivez-moi votre projet dans le champ ci-dessous.',
  'discover.toast.noResults.title': 'Aucune subvention trouvée',
  'discover.toast.noResults.description': 'Essayez d\'élargir vos critères de recherche.',
  'discover.toast.resultsFound.title': '{count} subvention(s) trouvée(s)',
  'discover.toast.resultsFound.description': 'Recherche effectuée en {time}ms',
  'discover.toast.searchError.title': 'Erreur de recherche',
  'discover.toast.searchError.description': 'Une erreur s\'est produite lors de la recherche. Veuillez réessayer.',

  // Loading/Transition state
  'discover.loading.analyzing': 'Analyse en cours...',
  'discover.loading.searchingBest': 'Recherche des meilleures subventions adaptées à votre profil',
  'discover.loading.aiWorking': 'Intelligence artificielle à l\'œuvre',
  'discover.loading.searchingSubsidies': 'Recherche des subventions adaptées...',

  // Results section
  'discover.results.newSearch': 'Nouvelle recherche',
  'discover.results.personalizedResults': 'Résultats IA personnalisés',
  'discover.results.advancedSearch': 'Recherche avancée',
  'discover.results.noResults': 'Aucun résultat disponible',

  // CTA section
  'discover.cta.title': 'Obtenez une aide personnalisée',
  'discover.cta.description': 'Créez votre profil pour une assistance complète dans vos démarches',
  'discover.cta.createProfile': 'Créer mon profil gratuit',
  'discover.cta.createProfileShort': 'Créer profil',
  'discover.cta.freeAssistance': 'Assistance gratuite',
  'discover.cta.assistance': 'Assistance',

  // Trial tracking
  'discover.trial.remaining': '{count} essais gratuits restants',
  'discover.trial.remainingSingular': '{count} essai gratuit restant',
  'discover.trial.lastWarning.title': 'Dernier essai gratuit',
  'discover.trial.lastWarning.description': 'Après cette utilisation, créez un compte (2€ pour 3 recherches) pour continuer à utiliser l\'assistant IA.',
  'discover.trial.exhausted.title': 'Essai gratuit terminé',
  'discover.trial.exhausted.description': 'Vous avez utilisé vos 3 recherches gratuites. Créez un compte pour continuer à utiliser l\'assistant IA et accéder à des recherches illimitées.',
  'discover.trial.createAccount': 'Créer un compte (2€ pour 3 recherches)',
  'discover.trial.signIn': 'Se connecter',

  // Conversational interface
  'discover.input.placeholder': 'Décrivez votre projet ou situation...',
  'discover.analyzing': 'En train d\'analyser...',
  'discover.conversationalDiscovery': 'Découverte conversationnelle',
  'discover.assistant.title': 'Assistant IA Subventions',
  'discover.preferences': 'préférences',

  // Path selector buttons
  'discover.path.business.button': 'Accéder au chatbot IA',
  'discover.path.individual.button': 'Simuler mes aides',
} as const;
